import { Translation } from '@fullyops/shared/pipes/translate.pipe';
import { AssetFormTranslationKey } from './translate.pipe';

export const es: Translation<AssetFormTranslationKey> = {
  name: 'Nombre',
  assetType: 'Tipo de activo',
  STANDALONE_EQUIPMENT: 'Equipo individual',
  EQUIPMENT_GROUP: 'Grupo de equipos',
  generic: 'genérico',
  active: 'Activado',
  createdAt: 'Creado el',
  company: 'Empresa',
  category: 'Categoría',
  companies: 'Empresas',
  location: 'Ubicación',
  locations: 'Ubicaciones',
  parent: 'Padre',
  description: 'Descripción',
  externalId: 'Identificador externo',
  criticality: 'Criticidad',
  LOW: 'Baja',
  MEDIUM: 'Media',
  HIGH: 'Alta',
  CRITICAL: 'Crítica',
  installedAt: 'Instalado el',
  hasWarranty: 'Tiene garantía',
  warrantyExpiresAt: 'La garantía vence el',
  warranty: 'Garantía',
  brand: 'Marca',
  model: 'Modelo',
  serialNumber: 'Número de serie',
  type: 'Tipo',
  manufacturedAt: 'Fabricado el',
  noneCriticality: 'Ninguna',
  noneGeneric: 'Ninguno',
  any: 'Cualquiera',
  assetClass: 'Clase de activo',
  noWarranty: 'No definida',
  inWarranty: 'En garantía',
  outOfWarranty: 'Fuera de garantía',
  create: 'Crear',
  assetsPerPage: 'Activos por página',
  inactive: 'Desactivado',
  change: 'Cambiar',
  genericType: 'Genérico',
  noCustomFields: 'Sin campos personalizados',
  oneCustomField: '1 campo personalizado',
  customFields: 'campos personalizados',
  chooseAssetType: 'Elija el tipo de activo',
  general: 'Información general',
  ownershipAndLocation: 'Propietario y ubicación',
  installationAndWarranty: 'Instalación y garantía',
  equipmentDetails: 'Detalles del equipo',
  customFieldsSection: 'Campos personalizados',
  attachments: 'Adjuntos',
  generalDescription: 'Qué es el activo y lo crítico que es',
  ownershipAndLocationDescription:
    'A quién pertenece, dónde está y de qué forma parte',
  installationAndWarrantyDescription:
    'Cuándo se instaló y hasta cuándo está en garantía',
  equipmentDetailsDescription: 'Datos del fabricante que identifican el equipo',
  customFieldsSectionDescription: 'Campos definidos para este tipo de activo',
  invalidInteger: 'Introduzca un número entero, p. ej. 12',
  invalidDecimal: 'Introduzca un número, p. ej. 12,5',
  status: 'Estado',
  valueOutOfRange: 'Fuera del rango permitido:',
  attachmentsDescription: 'Manuales, certificados, fotos y otros archivos',
  openAsset: 'Abrir activo',
  close: 'Cerrar',
  save: 'Guardar',
  add: 'Añadir',
  noCompanyAssets: 'Este cliente aún no tiene activos',
};
